import { type FeatureExtractionPipeline, env, pipeline } from "@huggingface/transformers";

const MODEL_ID = "Xenova/bge-small-en-v1.5";
const QUERY_PREFIX = "Represent this query for retrieving relevant documents: ";

// Serve the model from our own bundle, never from the HF CDN.
env.allowRemoteModels = false;
env.allowLocalModels = true;
env.localModelPath = "/data/model/";
env.useBrowserCache = true;

let pipePromise: Promise<FeatureExtractionPipeline> | null = null;

function getEmbedder(): Promise<FeatureExtractionPipeline> {
  if (!pipePromise) {
    // q8 = quantized int8 weights → ~33 MB instead of ~130 MB.
    pipePromise = pipeline("feature-extraction", MODEL_ID, {
      dtype: "q8",
    }) as Promise<FeatureExtractionPipeline>;
  }
  return pipePromise;
}

/**
 * Embed a search query as a normalized 384-d vector. Prepends the BGE retrieval
 * prefix so cosine distance is comparable with the document side.
 */
export async function embedQuery(text: string): Promise<Float32Array> {
  const pipe = await getEmbedder();
  const out = await pipe(QUERY_PREFIX + text, { pooling: "mean", normalize: true });
  // Tensor.data is a TypedArray view; copy so callers can safely transfer/JSON-stringify.
  return new Float32Array(out.data as Float32Array);
}

/** Eagerly start downloading the model — call once on app boot for a faster first query. */
export function warmUp(): Promise<unknown> {
  return getEmbedder();
}
